// utils/cartUtils.ts
export const validateCartPreorder = (
  cartItems: { is_preorder?: number }[],
  newProduct: { preorder_available?: number }
): boolean => {
  const newPreorder = newProduct?.preorder_available ?? 0;
  // If cart is empty, always valid
  if (cartItems.length === 0) return true;

  // Check if ALL existing items match the new product's preorder
  return cartItems.every((item) => Number(item?.is_preorder) === Number(newPreorder));
    
};
